import React, { useState } from 'react'
import Modal from 'react-modal'
import { AiFillCloseCircle } from 'react-icons/ai'
import { IconContext } from 'react-icons'
import { Formik, Form, Field } from 'formik'
import { Alert, Input } from '@wellbeingxltd/fe-lib/components'
import { Button } from 'components'
import { forgotPassword, forgotPasswordSubmit } from 'awsApi'
import { FORGOT_PASSWORD_MESSAGES, FORGOT_PASSWORD_SUBMIT_MESSAGES } from './constants'
import { emailSchema, newPasswordSchema } from '../../Landing/ForgotPassword/schema'

const ChangePassword = ({ modalIsOpen, closeModal }) => {
    const [loading, setLoading] = useState(false)
    const [emailSucceded, setEmailSuceeded] = useState(false)
    const [email, setEmail] = useState(false)

    const onSubmit = values => {
        setLoading(true)
        if (emailSucceded) {
            setLoading(false)
            const { email, password, confirmationCode: code } = values
            forgotPasswordSubmit(
                email,
                code,
                password,
                () => {
                    Alert(FORGOT_PASSWORD_SUBMIT_MESSAGES.success, 'success')
                    closeModal()
                },
                err => {
                    Alert(FORGOT_PASSWORD_SUBMIT_MESSAGES.error, 'error')
                }
            )
        } else {
            const { email } = values
            forgotPassword(
                email,
                () => {
                    Alert(FORGOT_PASSWORD_MESSAGES.success, 'success')
                    setEmailSuceeded(true)
                    setEmail(email)
                    setLoading(false)
                },
                () => {
                    setLoading(false)
                    Alert(FORGOT_PASSWORD_MESSAGES.error, 'error')
                }
            )
        }
    }

    const onCloseModal = () => {
        setEmailSuceeded(false)
        setEmail(false)
        closeModal()
    }

    return (
        <Modal isOpen={modalIsOpen} onRequestClose={onCloseModal} className="modal-container" overlayClassName="modal-overlay">
            <div className="module">
                <div className="module-header">
                    <h2>Change password</h2>
                    <div onClick={onCloseModal}>
                        <IconContext.Provider value={{ className: 'modal-close-button' }}>
                            <AiFillCloseCircle />
                        </IconContext.Provider>
                    </div>
                </div>
                <Formik
                    enableReinitialize={true}
                    initialValues={emailSucceded ? { email: email, password: '', confirmationCode: '' } : { email: '' }}
                    validationSchema={emailSucceded ? newPasswordSchema : emailSchema}
                    onSubmit={onSubmit}
                >
                    <Form>
                        <Field name="email">
                            {({ field, form, meta }) => <Input type="email" touched={meta.touched} error={meta.error} {...field} labelAbove="Work email" onBlurCapture={e => form.setFieldValue(e.target.name, e.target.value.trim().toLowerCase())} />}
                        </Field>
                        {emailSucceded && (
                            <>
                                <Field name="password">
                                    {({ field, meta }) => (
                                        <Input labelAbove="New password" type="password" {...field} error={meta.error} touched={meta.touched} />
                                    )}
                                </Field>
                                <Field name="confirmationCode">
                                    {({ field, meta }) => (
                                        <Input labelAbove="Confirmation code" {...field} error={meta.error} touched={meta.touched} />
                                    )}
                                </Field>
                            </>
                        )}
                        <Button {...{ className: 'modal-submit-button', loading, style: { marginTop: 'var(--sp32)' }, type: 'submit' }}>
                            CONTINUE
                        </Button>
                    </Form>
                </Formik>
            </div>
        </Modal>
    )
}

export default ChangePassword
